import React, { useState } from 'react';
import Layout from '../../layout/Layout';
import LoginForm from './LoginForm';
import { Snackbar } from '@bcmi-labs/react-components';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const Login = ({ customDomainInfo }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const loginCoppa = urlParams.get('loginCoppa');
  // boolean query param 1/0
  const googleAssistant = Number(urlParams.get('google_assistant'));
  const isMinor = Number(urlParams.get('is_minor'));
  const [selectedView, setSelectedView] = useState(loginCoppa);
  const [showChildAttemptSnackbar, setShowChildAttemptSnackbar] = useState(false);

  const { t } = useTranslation('login');

  return (
    <Layout logo={customDomainInfo?.organization_logo}>
      <LoginForm
        isFromCoppa={!!loginCoppa}
        googleAssistant={googleAssistant}
        isChild={selectedView === 'kid-login' || isMinor}
        onViewSelection={(value) => setSelectedView(value)}
        showChildAttempt={(value) => setShowChildAttemptSnackbar(value)}
        customDomainInfo={customDomainInfo}
      />
      <Snackbar
        message={t('login:childLoginAttempt')}
        isOpen={showChildAttemptSnackbar}
        onClose={() => setShowChildAttemptSnackbar(false)}
        turnOffAutoHide
        closeable
      ></Snackbar>
    </Layout>
  );
};

export default Login;

Login.propTypes = {
  customDomainInfo: PropTypes.object,
};
